import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { BiTranslateDirective } from "@globals/bi-translate";
import { CustomAnimations } from "@globals/classes/CustomAnimations";
import { BiSpinnerModule } from "@globals/components/spinner/bi-spinner.module";
import { MapEntryAddressStatusDto } from "@globals/openapi-models/model/mapEntryAddressStatusDto";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { finalize } from "rxjs";
import { AddressInfoBaseComponent } from "../bi-address-info-base.component";
import { BiAddressInfoTableComponent } from "../bi-address-info-table/bi-address-info-table.component";

@UntilDestroy()
@Component({
    selector: "bi-address-info-status",
    templateUrl: "./address-info-status-shared.component.html",
    styleUrl: "../bi-address-info-shared.component.scss",
    imports: [BiAddressInfoTableComponent, NgIf, BiSpinnerModule, BiTranslateDirective],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [CustomAnimations.fadeIn]
})
export class EntryAddressInfoStatusComponent extends AddressInfoBaseComponent<MapEntryAddressStatusDto> {
  public smsGroupId: number;

  ngOnInit() {
    super.ngOnInit();
    this.smsGroupId = this.dialogInputData.smsGroupId;
    this.getAddressInfo();
  }

  protected getAddressInfo() {
    this.addressService
      .getStatusForEntryAddress(this.address.street, this.address.number, this.address.letter, this.address.zipcode, this.dialogInputData.smsGroupId)
      .pipe(
        untilDestroyed(this),
        finalize(() => {
          this.isLoading.set(false);
          this.cd.markForCheck();
        })
      )
      .subscribe(addrezzez => {
        this.setRecipientDetails(addrezzez, true);
        this.checkIfThereAreMultipleTablesToAlign();
      });
  }
}
